import { createClient } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'
import { AiChatService } from '../../../../../proto/_gen/aiChat_connect'
import { SubscribeAiChatSessionRequest } from '../../../../../proto/_gen/aiChat_pb'
import { AiChatSession as ProtoAiChatSession } from '../../../../../proto/_gen/_gen.models_pb'
import { authenticator } from '../../../../pages/_shared/authService'
import type { AiChatSession } from 'poc-ai-biz-irdb_domain-model'
import { convertAiChatSessionToDomainModel } from '../../../../../proto/_gen.converters'

declare var IRDB_BACKEND_API_URL: string | undefined

export type SubscribeAiChatSessionResult = {
  session: AiChatSession
  aiChatEventIds: string[]
}

export const useSubscribeAiChatSession = () => {
  const backendApiUrl = IRDB_BACKEND_API_URL
  if (!backendApiUrl) {
    throw new Error('The IRDB_BACKEND_API_URL environment variable is not set')
  }

  const transport = createConnectTransport({
    baseUrl: backendApiUrl,
    interceptors: [authenticator],
  })
  const client = createClient(AiChatService, transport)

  return async function* (request: { sessionId: string }) {
    // domain-model型をProtobuf型に変換
    const protoRequest = new SubscribeAiChatSessionRequest({
      sessionId: request.sessionId,
    })

    const stream = client.subscribeAiChatSession(protoRequest)

    for await (const response of stream) {
      if (response.error) {
        throw new Error(response.error.message || 'Unknown error occurred during session subscription')
      }

      if (response.session) {
        // Protobuf AiChatSession を entities.ts AiChatSession に変換
        const convertedSession = convertAiChatSessionToDomainModel(response.session)

        yield {
          session: convertedSession,
          aiChatEventIds: response.aiChatEventIds,
        }
      }
    }
  }
}
